'use strict';

angular.module('ufcw')
  .controller('HistorialreservasController', function ($log,Request,$localstorage,$state,$rootScope,toaster,$uibModal,$document,$translate) {
    var vm = this;
    vm.errorMsg = null;
    var user  = $localstorage.getObject('user');

    vm.users = $localstorage.getObject('dependents');
    vm.has_dependent = (vm.users.length === 0)?false:true;
    vm.users.push(user);

    vm.animationsEnabled = true;
    vm.npsByReservation = {};

    vm.from_date = new Date();
    vm.from_date.setDate(vm.from_date.getDate() - 7);
    vm.to_date   = new Date();

    var config  = $localstorage.getObject('config');
    vm.useBuilding = config.useBuilding;

    $rootScope.user = user;
    $rootScope.headLander = true;
    $rootScope.titulopagina = $translate.instant('reserve.history');

    var STATUS_MAP = {
      RESERVED: $translate.instant('reserve.status_reserved'),
      CANCHARESERVED: $translate.instant('reserve.status_reserved'),
      CUPONERARESERVED: $translate.instant('reserve.status_reserved'),
      CANCELED: $translate.instant('reserve.status_canceled'),
      CANCHACANCELED: $translate.instant('reserve.status_canceled'),
      CUPONERACANCELED: $translate.instant('reserve.status_canceled'),
      null: '',
      '': '',
      undefined: '',
    };

    var ATTENDANCE_MAP = {
      1: $translate.instant('general.yes'),
      0: $translate.instant('general.no'),
      null: '-',
      '': '',
      undefined: '',
    };

    var days = [$translate.instant('days.sunday'), $translate.instant('days.monday'), $translate.instant('days.tuesday'), $translate.instant('days.wednesday'), $translate.instant('days.thursday'), $translate.instant('days.friday'), $translate.instant('days.saturday')];
    var months = [$translate.instant('months.january'), $translate.instant('months.february'), $translate.instant('months.march'), $translate.instant('months.april'), $translate.instant('months.may'), $translate.instant('months.june'), $translate.instant('months.july'),$translate.instant('months.august'),$translate.instant('months.september'),$translate.instant('months.october'),$translate.instant('months.november'),$translate.instant('months.december')];

    vm.load = function(){
      var params = "?from=2022-07-01&to=2023-01-01";
      var from = "";
      var to   = "";
      if(vm.from_date && vm.to_date){
        if(vm.from_date > vm.to_date){
          toaster.pop('info', "", $translate.instant('La fecha DESDE no puede ser mayor a la fecha HASTA'));
          return;
        }
        from = vm.from_date.getFullYear() + "-" + (vm.from_date.getMonth()+1) + "-" + vm.from_date.getDate();
        to = vm.to_date.getFullYear() + "-" + (vm.to_date.getMonth()+1) + "-" + vm.to_date.getDate();
        params = "?from="+from+"&to="+to;
      }

      Request.get('reservation/'+params,true,function(response) {
        if(response.status !== 0){
          toaster.pop('info', "", $translate.instant('api.'+response.description));
        }else{
          vm.reservas = response.description || [];
          var now = new Date();
          var reservationIds = [];
          var reservedStatuses = ['RESERVED','CUPONERARESERVED','CANCHARESERVED'];
          vm.npsByReservation = {};

          vm.reservas.forEach(function(item){
            item.statusRaw = item.status;
            item.attendanceRaw = item.attendance;
            if(item.reservationdate){
              item.reservationdate = item.reservationdate.replace(/-/g, '/');
            }
            var d = new Date(item.reservationdate);
            item.reservationDateObj = d;
            
            var dayName = days[d.getDay()];
            var dayNumber = d.getDate();
            var monthName = months[d.getMonth()];
            var year = d.getFullYear();
            item.day = dayName +" "+ dayNumber+ " " + $translate.instant("general.of") + " "+ monthName +" "+year;

            var hours = d.getHours().toString(); 
            var minutes = d.getMinutes().toString(); 
            hours = (hours.length===1)?"0"+hours:hours;
            minutes = (minutes.length===1)?minutes+"0":minutes;
            item.start_custom = hours + ":" + minutes;

            item.status = STATUS_MAP[item.statusRaw];
            item.attendance = ATTENDANCE_MAP[item.attendanceRaw];

            item.npsResponse = null;
            item.npsEligible = false;
            if(reservedStatuses.indexOf(item.statusRaw) !== -1 && !isNaN(d.getTime())){
              item.npsEligible = d < now;
            }

            if(item.id){
              reservationIds.push(item.id);
            }
          });

          vm.no_reservations = (vm.reservas.length === 0)?true:false;

          if(reservationIds.length){
            vm.fetchNps(reservationIds);
          }else{
            vm.npsByReservation = {};
          }
        }
      });
    };

    vm.load();

    vm.fetchNps = function(reservationIds){
      if(!reservationIds || reservationIds.length === 0){
        return;
      }
      var params = 'npssurvey/?reservationIds=' + reservationIds.join(',');
      Request.get(params,true,function(res){
        if(res.status !== 0){
          // if(console && console.warn){
          //   console.warn('NPS fetch error', res);
          // }
          return;
        }
        vm.npsByReservation = {};
        if(angular.isArray(res.description)){
          res.description.forEach(function(entry){
            var stored = angular.copy(entry);
            if(!stored || !stored.reservationId){
              return;
            }
            // if(stored && stored.score !== undefined && stored.score !== null){
            //   var numericScore = parseInt(stored.score, 10);
            //   stored.score = isNaN(numericScore) ? stored.score : numericScore;
            // }
            vm.npsByReservation[stored.reservationId] = stored;
          });
        }
        vm.reservas.forEach(function(item){
          if(vm.npsByReservation[item.id]){
            item.npsResponse = vm.npsByReservation[item.id];
          }
        });
      });
    };

  //DATETIMEPICKERS

  function getDayClass(data) {
    var date = data.date,
      mode = data.mode;
    if (mode === 'day') {
      var dayToCheck = new Date(date).setHours(0,0,0,0);

      for (var i = 0; i < vm.events.length; i++) {
        var currentDay = new Date(vm.events[i].date).setHours(0,0,0,0);

        if (dayToCheck === currentDay) {
          return vm.events[i].status;
        }
      }
    }

    return '';
  }

  vm.today = function() {
    vm.dt = new Date();
  };
  vm.today();

  vm.clear = function() {
    vm.dt = null;
  };

  vm.inlineOptions = {
    customClass: getDayClass,
    minDate: new Date(),
    showWeeks: true
  };

  // Disable weekend selection
  function disabled(data) {
    var date = data.date,
      mode = data.mode;
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  }

  vm.dateOptions = {
    dateDisabled: disabled,
    formatYear: 'yy',
    maxDate: new Date(2020, 5, 22),
    minDate: new Date(),
    startingDay: 1
  };

  vm.toggleMin = function() {
    vm.inlineOptions.minDate = vm.inlineOptions.minDate ? null : new Date();
    vm.dateOptions.minDate = vm.inlineOptions.minDate;
  };

  vm.toggleMin();

  vm.open1 = function() {
    vm.popup1.opened = true;
  };

  vm.open2 = function() {
    vm.popup2.opened = true;
  };

  vm.setDate = function(year, month, day) {
    vm.dt = new Date(year, month, day);
  };

  vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
  vm.format = vm.formats[0];
  vm.altInputFormats = ['M!/d!/yyyy'];

  vm.popup1 = {
    opened: false
  };

  vm.popup2 = {
    opened: false
  };

  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  var afterTomorrow = new Date();
  afterTomorrow.setDate(tomorrow.getDate() + 1);
  vm.events = [
    {
      date: tomorrow,
      status: 'full'
    },
    {
      date: afterTomorrow,
      status: 'partially'
    }
  ];

  vm.openGuests = function (size, parentSelector) {
    var parentElem = parentSelector ? 
      angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
    var modalInstance = $uibModal.open({
      animation: vm.animationsEnabled,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'guests.html',
      controller: 'ModalEditGuestsController',
      controllerAs: 'modalCtrl',
      size: size,
      backdrop: 'static',
      keyboard: false,
      appendTo: parentElem,
      resolve: {
        activity: function () {
          return vm.activity;
        }
      }
    });

    modalInstance.result.then(function () {
    }, function () {
      // $log.info('Modal dismissed at: ' + new Date());
    });
  };

  vm.openNps = function(reservation){
    var modalInstance = $uibModal.open({
      animation: vm.animationsEnabled,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'npssurvey.html',
      controller: 'ModalNpsSurveyController',
      controllerAs: 'modalCtrl',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        reservation: function(){
          return reservation;
        },
        existingResponse: function(){
          return angular.copy(reservation.npsResponse);
        }
      }
    });

    modalInstance.result.then(function(result){
      if(result && result.npsResponse){
        reservation.npsResponse = result.npsResponse;
        if(reservation.npsResponse && reservation.npsResponse.score !== "undefined" && reservation.npsResponse.score !== null){
          var modalScore = parseInt(reservation.npsResponse.score, 10);
          reservation.npsResponse.score = isNaN(modalScore) ? reservation.npsResponse.score : modalScore;
        }
        reservation.npsEligible = true;
      }
    }, function () {
      // modal dismissed
    });
  };

  vm.showGuests = function(activity){
    if(activity.allowGuest ===1 && angular.isString(activity.description)){
      activity.guests = activity.description.split(',');
      delete activity.description;
    }
    vm.activity = activity;
    vm.openGuests();
  };

});

angular.module('ufcw').controller('ModalNpsSurveyController', function ($uibModalInstance, Request, toaster, $translate, reservation, existingResponse) {
  var vm = this;

  vm.reservation = reservation;
  var reservationId = reservation ? reservation.id : null;
  vm.scale = [0,1,2,3,4,5,6,7,8,9,10];
  vm.score = null;
  if(existingResponse && existingResponse.score !== "undefined" && existingResponse.score !== null){
    var parsedScore = parseInt(existingResponse.score, 10);
    vm.score = isNaN(parsedScore) ? null : parsedScore;
  }
  vm.comment = existingResponse && existingResponse.comment ? existingResponse.comment : '';
  vm.isSaving = false;

  vm.setScore = function(value){
    vm.score = value;
  };

  vm.submit = function(){
    if(vm.score === null || vm.score === "undefined"){
      toaster.pop('error','', $translate.instant('api.npssurvey.score_required'));
      return;
    }
    vm.isSaving = true;
    var commentText = vm.comment ? vm.comment.trim() : '';
    if(!reservationId){
      toaster.pop('error','', $translate.instant('api.npssurvey.invalid_reservation'));
      vm.isSaving = false;
      return;
    }
    var payload = {
      reservationId: reservationId,
      score: vm.score,
      comment: commentText
    };

    Request.post('npssurvey/', true, payload, function(response){
      vm.isSaving = false;
      if(response.status !== 0){
        var key = response.description;
        if(!key){
          key = 'api.npssurvey.invalid_reservation';
        }else if(key.indexOf('api.') !== 0){
          key = 'api.' + key;
        }
        toaster.pop('error','', $translate.instant(key));
        return;
      }
      toaster.pop('success','', $translate.instant('reserve.nps_success'));
      $uibModalInstance.close({ npsResponse: response.description });
    });
  };

  vm.cancel = function(){
    $uibModalInstance.dismiss('cancel');
  };
});
